import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css, cx }) => {
  return {
    container: css`
      padding: 0 ${token.paddingXS}px;
      background: #fff;
      border-radius: ${token.borderRadiusLG}px;
      box-shadow: ${token.boxShadowTertiary};
      height: 58px;
      /* display: flex; */
      /* align-items: center; */
      /* align-self: stretch; */
    `,
    notBind: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    `,
    bind: css`
      height: 100%;
    `,
  };
});
